const topics = [
  { label: '浪漫电影推荐', heat: '9.8万讨论' },
  { label: '夫妻必看影视', heat: '8.5万讨论' },
  { label: '情侣影院', heat: '7.2万讨论' },
  { label: '二人世界电影', heat: '6.9万讨论' },
  { label: '高清在线观看', heat: '6.1万讨论' },
  { label: '免费不缓冲', heat: '5.7万讨论' },
  { label: '七夕观影', heat: '5.3万讨论' },
  { label: '经典爱情片', heat: '4.8万讨论' },
  { label: '婚姻家庭剧', heat: '4.2万讨论' },
  { label: '日韩纯爱', heat: '3.9万讨论' },
  { label: '欧美浪漫', heat: '3.5万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            话题广场
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            看看大家都在聊哪些夫妻电影与情侣影院相关内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-2 bg-background-100 border border-background-200/70 hover:border-primary-300/60 hover:bg-primary-50/50 rounded-full px-4 py-2.5 cursor-pointer transition-all duration-300"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{item.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200/80 px-2 py-0.5 rounded-full whitespace-nowrap">
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}